module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "search__result",
    class: {
      active: _vm.isActive
    },
    attrs: {
      "id": ("result_" + (_vm.note.id))
    },
    on: {
      "dblclick": _vm.onRenameFocus,
      "!click": function($event) {
        _vm.onResultSelect($event)
      },
      "mouseenter": function($event) {
        _vm.showDelete = true
      },
      "mouseleave": function($event) {
        _vm.showDelete = false
      }
    }
  }, [(_vm.renaming) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.note.name),
      expression: "note.name"
    }, {
      name: "focus",
      rawName: "v-focus"
    }],
    staticClass: "search__result__editor",
    attrs: {
      "id": ("search-result-editor-" + (_vm.note.id)),
      "type": "text"
    },
    domProps: {
      "value": (_vm.note.name)
    },
    on: {
      "blur": _vm.onRenameBlur,
      "keyup": [function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "esc", 27)) { return null; }
        _vm.onRenameBlur($event)
      }, function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.onRenameSave($event)
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.note.name = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), (!(_vm.renaming)) ? [_c('span', {
    staticClass: "search__result__name"
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.name)
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.note.body.length > 0),
      expression: "note.body.length > 0"
    }],
    staticClass: "search__result__description"
  }, [_vm._v(" \n        – " + _vm._s(_vm.note.body) + "\n      ")])]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showDelete),
      expression: "showDelete"
    }],
    staticClass: "search__result__delete",
    on: {
      "click": _vm.onDelete
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.showDelete),
      expression: "!showDelete"
    }],
    staticClass: "search__result__time"
  }, [_vm._v("\n      " + _vm._s(_vm._f("prettyDate")(_vm.note.date_modified)) + "\n    ")])] : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2181c8e3!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Search/SearchResult.vue
// module id = 2120
// module chunks = 0